<template src="./ratePlanList.template.html"></template>
<script>
    import * as axios from "axios";
    import $ from "jquery";
    import moment from "moment-timezone";

    export default {
        // options
        name: "ratePlanList",
        props: [],
        data(){
            return {
                statusList: [],
                statusId: 1,
                ratePlanList: [],
                ratePlanId: -1,
                loading: false,
                headerColumnList: {
                    INTERNALNAME: {
                        Label: "INTERNAL NAME",
                        IsChecked: true,
                        ColumnName: "RatePlan_Name",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    EXTERNALNAME: {
                        Label: "EXTERNAL NAME",
                        IsChecked: true,
                        ColumnName: "RatePlan_DisplayName",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    DERIVED: {
                        Label: "DERIVED",
                        IsChecked: true,
                        ColumnName: "IsDerived",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    STATUS: {
                        Label: "STATUS",
                        IsChecked: true,
                        ColumnName: "StatusId",
                        columnClass: "numeriColumn",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    BASERATEPLAN: {
                        Label: "BASERATEPLAN",
                        IsChecked: true,
                        ColumnName: "ParentRateplanName",
                        columnClass: "BASERATEPLAN",
                        isSortLoading: false,
                        isAscOrDesc: null
                    },
                    CALUCLATION: {
                        Label: "CALUCLATION",
                        IsChecked: true,
                        ColumnName: "DerivedOffsetAmount",
                        columnClass: "caluclation",
                        isSortLoading: false,
                        isAscOrDesc: null
                    }

                },
                ratePlanDetailList: [],
            }
        },

        methods: {

            getPropertyMetaData: function () {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetPropertiesBySearchText",
                    params: {},
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("GetPropertiesBySearchText==>", response);
                            // vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
                            vm.statusList.splice(0, vm.statusList.length, ...response.statusList);
                        }
                    }
                });
            },

            getRatePlanDetailList(){
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_RatePlanList",
                    params: {
                        sortBy: vm.sortBy,
                        sortOrder: vm.sortOrder,
                        StatusId: vm.statusId,
                        RatePlanId	: vm.ratePlanId,
                        searchText: null
                    },
                    callback: function (err, response) {
                        if (err) {
                            vm.$store.dispatch("toaster", {
                                type: "error",
                                header: "Error",
                                message: "In getting Rate Plan list"
                            });
                            return;
                        }
                        if (response) {
                            console.log("Get_RatePlanList==>", response);
                            if (response[1]) {
                                vm.ratePlanDetailList.splice(0, vm.ratePlanDetailList.length, ...response[1]);
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Rate Plan list rendered successfully"
                                });
                            }
                        }
                    }
                });
            },
            ratePlanDetail(ratePlanId) {
                let vm = this;
                vm.$router.push("/ratePlanDetail/" + ratePlanId);
            },
             ascSort(column, sortOrder) {
                let vm = this;
                vm.sortBy = column.ColumnName;
                vm.sortOrder = sortOrder;
                for (var headerColumn of vm.headerColumnList) {
                    if (headerColumn) {
                        if (column.ColumnName.toString() === headerColumn.ColumnName) {
                            console.log("obj.ColumnName", headerColumn.ColumnName);
                            headerColumn.isSortLoading = true;
                            headerColumn.isAscOrDesc = sortOrder.toString();
                        }
                    }
                }
                vm.getRatePlanDetailList();
            }
           
        },

        computed: {},

        watch: {},
        created() { },
        mounted() {
           let vm = this;
           vm.getPropertyMetaData();
           vm.getRatePlanDetailList();
        }
    };
</script>